module.exports = __webpack_public_path__ + "img/support_paid_sick_days_chalk.865a62ab.jpeg";